import { type ReactNode } from "react";
import { useAuth } from "../auth/authContext.ts";
import { C, SANS, SERIF } from "../ui/theme.ts";
import { LogoArgus } from "../ui/iconos.tsx";

/** Cascarón común de los dos planos: cabecera + navegación + contenido. */
export function Shell({
  titulo,
  nav,
  children,
}: {
  titulo: string;
  nav: ReactNode;
  children: ReactNode;
}) {
  const { session, setSession } = useAuth();
  return (
    <div style={{ fontFamily: SANS, minHeight: "100vh", background: C.bg, color: C.ink }}>
      <header
        className="argus-shell-header"
        style={{
          display: "flex",
          alignItems: "center",
          gap: "1.25rem",
          padding: "0.75rem 1.25rem",
          borderBottom: `1px solid ${C.line}`,
          background: "#fff",
        }}
      >
        <span style={{ display: "inline-flex", alignItems: "center", gap: 9, whiteSpace: "nowrap" }}>
          <LogoArgus alto={18} color={C.tiel} />
          <strong style={{ fontFamily: SERIF, fontWeight: 500, letterSpacing: "0.14em", fontSize: 15 }}>ARGUS</strong>
          <span style={{ color: C.muted, fontSize: 13 }}>· {titulo}</span>
        </span>
        <nav className="argus-shell-nav" style={{ display: "flex", gap: 8, flex: 1 }}>{nav}</nav>
        <span style={{ fontSize: 13, color: C.muted }}>
          {session?.nombre} · {session?.rol}
        </span>
        <button
          style={{
            padding: "0.4rem 0.7rem",
            borderRadius: 8,
            border: `1px solid ${C.line}`,
            background: "#fff",
            color: C.ink,
            cursor: "pointer",
          }}
          onClick={() => { setSession(null); }}
        >
          Salir
        </button>
      </header>
      <main className="argus-shell-main" style={{ padding: "1.5rem", maxWidth: 960, margin: "0 auto" }}>{children}</main>
    </div>
  );
}

const PESO_ACTIVO = 600;
const PESO_INACTIVO = 500;

/** Botón de navegación interno (resalta la sección activa). */
export function NavBtn({
  activo,
  onClick,
  children,
}: {
  activo: boolean;
  onClick: () => void;
  children: ReactNode;
}) {
  return (
    <button
      onClick={onClick}
      style={{
        padding: "0.4rem 0.8rem",
        borderRadius: 8,
        border: "1px solid " + (activo ? C.tiel : "transparent"),
        background: activo ? C.tielSoft : "transparent",
        color: activo ? C.tielDark : C.muted,
        cursor: "pointer",
        fontSize: 14,
        fontWeight: activo ? PESO_ACTIVO : PESO_INACTIVO,
      }}
    >
      {children}
    </button>
  );
}
